import React from "react";
import {ShapeLineControl} from "./ShapeLineControl";
import Box, {Item,} from 'devextreme-react/box';
import {useCountertops} from "../../contexts/countertopsContext";
import {ShapesTotalControl} from "./ShapesTotalControl";

export function CountertopControl() {
    const data = useCountertops();

    return (
        <>
            <Box
                direction="row"
                width="100%"
                align="center"
                crossAlign="center"
            >
                <Item ratio={6}>
                    <p className={"box-header"}>
                        Countertop Details*
                    </p>
                </Item>
                <Item ratio={4}>
                    <p className={"box-header"}>
                        Calculator
                    </p>
                </Item>
            </Box>
            {data.shapes.map((shape) =>
                <ShapeLineControl key={shape.id} shape={shape} />
            )}
            <Box
                direction="row"
                width="100%">
                <Item ratio={6}>
                    <a style={{ textDecoration: "none", marginLeft: '10px' }}
                        onClick={() => data.addShape()}><i
                            className="dx-icon-add"></i>Add Shape</a>
                </Item>
                <Item ratio={4}>
                </Item>
            </Box>
            <ShapesTotalControl></ShapesTotalControl>
        </>
    );
}
